import { errors } from "../constants";
import {
  createErrorResult,
  IWaitingListPassengerDto,
  IWaitingListQueueResponseDto,
  SimpleResult,
} from "../dto";
import { Api, getCompanyId } from "../helpers";

export class WaitingListApi {
  static async getQueue(
    rideId: number,
    abortController?: AbortController,
  ): Promise<SimpleResult<IWaitingListQueueResponseDto> | undefined> {
    const companyId = getCompanyId();

    if (!rideId) {
      return undefined;
    }

    const requestUrl = `/api/v1/core/c/${companyId}/rides/${rideId}/waiting-list`;
    const response = await Api.get<
      SimpleResult<IWaitingListQueueResponseDto> | undefined
    >(requestUrl, undefined, abortController);

    return response?.data;
  }

  static async removePassenger({
    rideId,
    passengerId,
    abortController,
  }: {
    rideId: number;
    passengerId: number;
    abortController?: AbortController;
  }): Promise<SimpleResult<{ id: number }> | undefined> {
    const companyId = getCompanyId();

    if (!rideId || !passengerId) {
      return createErrorResult<{ id: number }>(errors.common.emptyApiResponse);
    }

    const requestUrl = `/api/v1/core/c/${companyId}/rides/${rideId}/waiting-list/${passengerId}`;
    const response = await Api.delete<SimpleResult<{ id: number }>>(
      requestUrl,
      undefined,
      abortController,
    );

    return response?.data;
  }

  static async restorePassenger({
    rideId,
    passengerId,
    abortController,
  }: {
    rideId: number;
    passengerId: number;
    abortController?: AbortController;
  }): Promise<SimpleResult<IWaitingListPassengerDto> | undefined> {
    const companyId = getCompanyId();

    if (!rideId || !passengerId) {
      return createErrorResult<IWaitingListPassengerDto>(
        errors.common.emptyApiResponse,
      );
    }

    const requestUrl = `/api/v1/core/c/${companyId}/rides/${rideId}/waiting-list/${passengerId}/restore`;
    const response = await Api.post<SimpleResult<IWaitingListPassengerDto>>(
      requestUrl,
      {},
      abortController,
    );

    return response?.data;
  }

  static async sendInvitation({
    rideId,
    passengerId,
    abortController,
  }: {
    rideId: number;
    passengerId: number;
    abortController?: AbortController;
  }): Promise<SimpleResult<IWaitingListPassengerDto> | undefined> {
    const companyId = getCompanyId();

    if (!rideId || !passengerId) {
      return createErrorResult<IWaitingListPassengerDto>(
        errors.common.emptyApiResponse,
      );
    }

    const requestUrl = `/api/v1/core/c/${companyId}/rides/${rideId}/waiting-list/${passengerId}/sendInvitation`;
    const response = await Api.post<SimpleResult<IWaitingListPassengerDto>>(
      requestUrl,
      {},
      abortController,
    );

    return response?.data;
  }
}
